// Front/src/api.js

import CONFIG from "./config"; // Import config.js
import axios from "axios";

const { API_URL, CURRENT_VERSION } = CONFIG;

// 🔹 Login function (Calls API directly)
export async function login(userId, password) {
    if (!userId || !password) {
        // for debugging
        // console.error("Missing login credentials");
        return { error: "All fields must be filled" };
    }
//console.log('CURRENT_VERSION', CURRENT_VERSION);
    try {
        const response = await axios.post(`${API_URL}/api/technet/login`, {
            version: CURRENT_VERSION,
            id: userId,
            password: password
        }, {
            headers: {
                "Content-Type": "application/json"
            },
            withCredentials: true
        });

        const userData = response.data;

       
        return userData;

    } catch (error) {
        // for debuggin
            console.error("Login failed:", error);
          console.error("Login failed:you", error.response?.data);
        return {
            error: error.response?.data || error.response?.data?.Message || error.response?.data?.message || "Failed to connect to API",
            status: error.response?.status || 500,
        };
    }
}


// upload function without using server.js
// 🔹 Upload function (Calls Azure API directly)
export async function upload(jsonData, userId) {

    const storedUser = JSON.parse(localStorage.getItem("user"));
    const token = storedUser?.token;
    if (token == null) {
        return { error: "Invalid Token" };
    }

    if (!jsonData) {
        // for debugging
        // console.error("Missing JSON data");
        return { error: "Missing JSON data" }; // Fixed: React should return an object, not `res.status(...)`
    }

    try {
        const response = await axios.post(`${API_URL}/api/upload/shortscalereport`, jsonData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            withCredentials: true, // If your API requires authentication cookies
        });

        return response; // Return response directly to React

    } catch (error) {
        // for debugging
        //console.error("Upload failed:", error);

        return {
            error: error.response?.data?.Message || error.response?.data?.message || "Failed to upload data",
            status: error.response?.status || 500,
        };
    }
}

// 🔹 Fixed `get_scale_from_webapi` (No `/external/`)
export async function get_scale_from_webapi(userId, scaleId) {

    const storedUser = JSON.parse(localStorage.getItem("user"));
    const token = storedUser?.token;
    if (token == null) {
        return { error: "Invalid Token" };
    }

    try {
        const response = await axios.get(`${API_URL}/api/scale/${scaleId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
            },
            withCredentials: true,
        });

        return response.data;

    } catch (error) {
        // for debugging
        //console.error("Failed to get scale:", error);
        return {
            error: error.response?.data?.Message || error.response?.data?.message || "Failed to fetch scale data",
            status: error.response?.status || 500,
        };
    }
}

// 🔹 Fixed `logout_from_webapi` (uses POST securely)
export async function logout_from_webapi(userId) {
    try {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        const token = storedUser?.token;
        if (token == null) {
            return { error: "Invalid Token" };
        }    

        const response = await axios.post(`${API_URL}/api/logout`, {
            id: userId
        }, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
            withCredentials: true,
        });

        // for debugging
        //const responseData = response.data;
        //console.log("✅ Logout successful:", responseData);
        return response;

    } catch (error) {
        // for debugging
        //console.error("Logout failed:", error);
        return {
            error: error.response?.data?.Message || error.response?.data?.message || "Failed to logout",
            status: error.response?.status || 500,
        };
    }
}


// 🔹 Fixed `get_client_from_webapi` (No `/external/`)
export async function get_client_from_webapi(userId, clientId) {

    try {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        const token = storedUser?.token;
        if (token == null) {
            return { error: "Invalid Token" };
        }
    
        const response = await axios.get(`${API_URL}/api/client/${clientId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
            },
            withCredentials: true,
        });

        return response;

    } catch (error) {
        // for debugging
        //console.error("Failed to get client details:", error);
        return {
            error
        };
    }
}

// 🔹 Fixed `get_catalog_details_from_webapi` (No `/external/`)
export async function get_catalog_details_from_webapi(userId, catalogId) {

    try {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        const token = storedUser?.token;
        if (token == null) {
            return { error: "Invalid Token" };
        }
    
        const response = await axios.get(`${API_URL}/api/scaletype/${catalogId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
            },
            withCredentials: true,
        });

        return response;

    } catch (error) {
        // for debugging
        //console.error("Failed to get catalog details:", error);
        return {
            error
        };
    }
}

// 🔹 Fixed `get_thermometer_id_from_webapi` (No `/external/`)
export async function get_thermometer_id_from_webapi(userId) {

    try {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        const token = storedUser?.token;
        if (token == null) {
            return { error: "Invalid Token" };
        }
    
        const response = await axios.get(`${API_URL}/api/thermometer/technician/${userId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
            },
            withCredentials: true,
        });

        return response;

    } catch (error) {
        // for debugging
        //console.error("Failed to get thermometer:", error);
        return {
            error
        };
    }
}

// 🔹 Fixed `get_weight_sets_ids_from_webapi` (No `/external/`)
export async function get_weight_sets_ids_from_webapi(userId) {

    try {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        const token = storedUser?.token;
        if (token == null) {
            return { error: "Invalid Token" };
        }
    
        const response = await axios.get(`${API_URL}/api/weightset/technician/${userId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
            },
            withCredentials: true,
        });

        return response;

    } catch (error) {
        // for debugging
        //console.error("Failed to get weight sets:", error);
        return {
            error
        };
    }
}

// upload function without using server.js
// 🔹 Upload Scale function (Calls Azure API directly)
export async function upload_scale(jsonData, userId) {

    if (!jsonData) {
        // for debugging
        //console.error("Missing JSON data");
        return { error: "Missing JSON data" }; // ✅ Fixed: React should return an object, not `res.status(...)`
    }

    try {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        const token = storedUser?.token;
        if (token == null) {
            return { error: "Invalid Token" };
        }
    
        const response = await axios.post(`${API_URL}/api/upload/shortscale`, jsonData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            withCredentials: true, // If your API requires authentication cookies
        });

        return response; // Return response directly to React

    } catch (error) {
        // for debugging
        //console.error("Upload failed:", error);

        return {
            error: error.response?.data?.Message || error.response?.data?.message || "Failed to upload data",
            status: error.response?.status || 500,
        };
    }
}

// upload function without using server.js
// 🔹 Upload Client function (Calls Azure API directly)
export async function upload_client(jsonData, userId) {

    if (!jsonData) {
        // for debugging
        //console.error("Missing JSON data");
        return { error: "Missing JSON data" }; // ✅ Fixed: React should return an object, not `res.status(...)`
    }

    try {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        const token = storedUser?.token;
        if (token == null) {
            return { error: "Invalid Token" };
        }
    
        const response = await axios.post(`${API_URL}/api/upload/shortclient`, jsonData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            withCredentials: true, // If your API requires authentication cookies
        });

        return response; // Return response directly to React

    } catch (error) {
        // for debugging
        //console.error("Upload failed:", error);

        return {
            error: error.response?.data?.Message || error.response?.data?.message || "Failed to upload data",
            status: error.response?.status || 500,
        };
    }
}

// upload function without using server.js
// 🔹 Upload ScaleType function (Calls Azure API directly)
export async function upload_scale_type(jsonData) {

    if (!jsonData) {
        // for debugging
        //console.error("Missing JSON data");
        return { error: "Missing JSON data" }; // ✅ Fixed: React should return an object, not `res.status(...)`
    }

    try {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        const token = storedUser?.token;
        if (token == null) {
            return { error: "Invalid Token" };
        }
    
        const response = await axios.post(`${API_URL}/api/upload/shortscaletype`, jsonData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            withCredentials: true, // If your API requires authentication cookies
        });

        return response; // Return response directly to React

    } catch (error) {
        // for debugging
        //console.error("Upload failed:", error);

        return {
            error: error.response?.data?.Message || error.response?.data?.message || "Failed to upload data",
            status: error.response?.status || 500,
        };
    }
}

// 🔹 Fetch the latest ScaleReport for a specific scale ID, docno, and sern
export async function get_latest_scale_report(scaleId, docno, sern) {
    try {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        const token = storedUser?.token;
        if (token == null) {
            return { error: "Invalid Token" };
        }    

        const response = await axios.post(
            `${API_URL}/api/scalereport/scale/${scaleId}/docno/${docno}/sern/${sern}`,
            {}, // POST body is empty for this API
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                withCredentials: true,
            }
        );

        return response.data;

    } catch (error) {
        return {
            error: error.response?.data?.Message || error.response?.data?.message || "Failed to fetch latest scale report",
            status: error.response?.status || 500,
        };
    }
}
